import { PhotoType, PositionType } from '../services/PhotoService';
import { FILE_UPLOAD_FAILED_KEY } from '../../../services/DeliveryDataService';

/**
 * 照片处理工具类
 */
export class PhotoProcessingUtils {
    /**
     * 处理照片URL清理逻辑 - 如果图片上传成功则清空URL
     * @param photosArray 新版本照片数组
     * @param photos 老版本照片对象
     * @param useMultiPhotoSelector 是否使用多图选择器
     * @param requireUploadedOnly 是否只保留已上传的照片（用于异常标记等场景）
     * @returns 处理后的照片数组
     */
    static processPhotosForSaving(
        photosArray: PhotoType[],
        photos: Record<PositionType, PhotoType | undefined>,
        useMultiPhotoSelector: boolean,
        requireUploadedOnly: boolean = false
    ): { type: PositionType; photo: PhotoType }[] {
        if (useMultiPhotoSelector) {
            // 新版本：数组形式
            let filteredPhotos = photosArray;

            // 如果需要只保留已上传的照片
            if (requireUploadedOnly) {
                filteredPhotos = photosArray.filter(photo =>
                    photo?.url && photo?.objectKey && photo.objectKey !== FILE_UPLOAD_FAILED_KEY
                );
            }

            return filteredPhotos.map((photo, index) => ({
                type: `photo_${index}` as PositionType,
                photo: {
                    ...photo,
                    // 如果图片上传成功（objectKey不等于FILE_UPLOAD_FAILED_KEY），则清空url
                    url: photo.objectKey && photo.objectKey !== FILE_UPLOAD_FAILED_KEY ? 'success' : photo.url
                } as PhotoType
            }));
        } else {
            // 老版本：对象形式
            let photoEntries = Object.entries(photos || {})
                .filter(([_, photo]) => photo !== undefined);

            // 如果需要只保留已上传的照片
            if (requireUploadedOnly) {
                photoEntries = photoEntries.filter(([_, photo]) =>
                    photo?.url && photo?.objectKey && photo.objectKey !== FILE_UPLOAD_FAILED_KEY
                );
            }

            return photoEntries.map(([type, photo]) => ({
                type: type as PositionType,
                photo: {
                    ...photo!,
                    // 如果图片上传成功（objectKey不等于FILE_UPLOAD_FAILED_KEY），则清空url
                    url: photo!.objectKey && photo!.objectKey !== FILE_UPLOAD_FAILED_KEY ? 'success' : photo!.url
                } as PhotoType
            }));
        }
    }
}
